import { reportG10 } from "./../services/reportG10.service";
import { MessageBox, Loading } from "element-ui";
const moment = require("moment");
const month_th = [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
const state = {
  showChart : false,
  showDataNotFound: false,
  prototype: {
    chart: {
      type: "column",
      // options3d: {
      //     enabled: true,
      //     // alpha: 15,
      //     alpha: 10,
      //     // beta: 15,
      //     beta: 0,
      //     depth: 0,
      //     viewDistance: 0
      //   },
    },
    title: {
      text: "",
      align: "center",
     
    },
    yAxis: {
      min: 0,
      title: {
        text: "จำนวนรายการส่งเสริมการขาย (รายการ)"
      },
      labels: {
        //  formatter: function() {
        //     return formatNumber(this.value);
        //  }
        // format: '{value:.2f}'
      },
      // tickInterval:200
    },
    xAxis: {
      // type: 'category',
      labels: {
        style: {
          fontSize: '5px'
        }
      }
    },
    credits: {
        enabled: false
    },
    tooltip: {
      formatter: function() {
        return '<b>' + this.series.name + '</b><br><b>' + this.point.name+': ' + this.point.y + ' รายการ'+'</b>';
       },
    },
    plotOptions: {
      column: {
        // stacking: 'normal',
        dataLabels:{
          crop : false,
          enabled: true,
          formatter: function(){
            return formatNumber(this.point.y);
          },
          x: -2.5,
          y: -2,
          inside: false,
          allowOverlap: true,
          style: {
            textOutline : '0.15 px contrast'
          }
        },
        borderWidth: 0
      }
    },
    series: [
      
    ],
    drilldown: {
      allowPointDrilldown: true,
      series: []
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom"
            }
          }
        }
      ]
    },
    exporting: {
      buttons: {
          contextButton:{
              menuItems: ["viewFullscreen", "printChart", "separator", "downloadCSV", "downloadXLS", "viewData"]
          }
      },
      chartOptions: {
        plotOptions: {
            column: {
              // stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '8px'
                    }
                }
            }
        },
        title: {
            style: {
                fontSize: '13px'
            }
        },
        legend: {
            itemStyle: {
                fontSize: '9px'
            }
        },
        xAxis: {
          labels: {
            style:{
              fontSize: '9px'
            }
          }
        },
        yAxis: {
          labels: {
            style:{
              fontSize: '9px'
            }
          }
        },
        scale: 2,
        chart: {
          height: 440,
          width: 1080
        },
        sourceHeight: 440,
        sourceWidth: 1080
      },
    }
  },
  charts: [],
  datasets:[],
}
const actions = {
    async setChartData({ commit }, formdata) {
      let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
      let result = await reportG10.getReportData(formdata);
      if (result.status === 200) {
        if(result.data.length==0){
          state.showChart = false
          state.showDataNotFound = true
          state.charts = []
          setTimeout(function(){ loadingInstance.close() }, 250);
        } else {
          state.showChart = true
          state.showDataNotFound = false
          let obj = null
          switch (formdata.type_report) {
            case "month": {
              obj = {
                forminfo: formdata,
                qrydata: result.data,
                date: {
                  start: moment(formdata.type_data.month).format('YYYY-MM-DD'),
                  end: moment(formdata.type_data.month).add(1, 'M').subtract(1, 'd').format('YYYY-MM-DD')
                }
              };
              break;
            }
            case "between_month": {
              obj = {
                forminfo: formdata,
                qrydata: result.data,
                date: {
                  start: moment(formdata.type_data.monthfrom).format('YYYY-MM-DD'),
                  end: moment(formdata.type_data.monthto).add(1 ,'M').subtract(1, 'd').format('YYYY-MM-DD')
                }
              };
              break;
            }
            case "year": {
              obj = {
                forminfo: formdata,
                qrydata: result.data,
                date: {
                  start: moment(formdata.type_data.year).format('YYYY-MM-DD'),
                  end: moment(formdata.type_data.year).add(1, 'Y').subtract(1, 'd').format('YYYY-MM-DD')
                }
              };
              break;
            }
            case "between_year": {
              obj = {
                forminfo: formdata,
                qrydata: result.data,
                date: {
                  start: moment(formdata.type_data.yearfrom).format('YYYY-MM-DD'),
                  end: moment(formdata.type_data.yearto).add(1, 'Y').subtract(1, 'd').format('YYYY-MM-DD')
                }
              };
              break;
            }
            case "quarter": {
              obj = {
                forminfo: formdata,
                qrydata: result.data,
                date: {
                  start: moment(formdata.type_data.quarter_year).add((formdata.type_data.quarter - 1) * 3, 'M').format('YYYY-MM-DD'),
                  end: moment(formdata.type_data.quarter_year).add(formdata.type_data.quarter * 3, 'M').subtract(1, 'd').format('YYYY-MM-DD')
                }
              };
              break;
            }
            case "between_quarter": {
              obj = {
                forminfo: formdata,
                qrydata: result.data,
                date: {
                  start: moment(formdata.type_data.quarter_year_from).add((formdata.type_data.quarterfrom - 1) * 3, 'M').format('YYYY-MM-DD'),
                  end: moment(formdata.type_data.quarter_year).add(formdata.type_data.quarterto * 3, 'M').subtract(1, 'd').format('YYYY-MM-DD')
                }
              };
              break;
            }
          }
          commit('SET_CHART', obj)
          setTimeout(function(){ loadingInstance.close() }, 250);
        }
      }else {
        setTimeout(function(){ loadingInstance.close() }, 250);
        MessageBox.confirm(result.message, "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        });
      }
    }
};

const mutations = {
  SET_CHART(state, obj){
    state.charts = []
    let newChart = JSON.parse(JSON.stringify(state.prototype))
    let technology = obj.forminfo.type_search
    let providers = obj.forminfo.list
    let nameProvider = []
    for(let i = 0; i < providers.length; i++){
        nameProvider.push(obj.forminfo.compare_type == "group" ? providers[i].group_name_th : providers[i].brand_name)
    } 
    let tc = ""
    if (nameProvider.length == 1) {
      tc = nameProvider[0]
    } else if (nameProvider.length == 2) {
      tc = nameProvider[0]+" และ "+nameProvider[1]
    } else if (nameProvider.length > 2) {
      for(let i = 0; i < nameProvider.length - 1; i++){
        tc += nameProvider[i]
        if(i!=nameProvider.length - 2){
          tc += ', '
        }
      }
      tc += " และ " + nameProvider[nameProvider.length-1]
    }
    let title = "รายงานจำนวนรายการส่งเสริมการขายบริการอินเทอร์เน็ตความเร็วสูงประจำที่ในรูปแบบเทคโนโลยี " + technology + " ของผู้ให้บริการ " + tc
    switch (obj.forminfo.type_report) {
      case 'month':
        title +=  ` เดือน${month_th[moment(obj.date.start).month()]} ปี พ.ศ. ${moment(obj.date.start).add(543, 'Y').year()}`
        break;
      case 'between_month':
        title +=  ` ระหว่างเดือน${month_th[moment(obj.date.start).month()]} ปี พ.ศ. ${moment(obj.date.start).add(543, 'Y').year()} ถึงเดือน${month_th[moment(obj.date.end).month()]} ปี พ.ศ. ${moment(obj.date.end).add(543, 'Y').year()}`
        break;
      case 'year':
        title +=  ` ปี พ.ศ. ${moment(obj.date.start).add(543, 'Y').year()}`
        break;
      case 'between_year':
        title +=  ` ระหว่างปี พ.ศ. ${moment(obj.date.start).add(543, 'Y').year()} ถึงปี พ.ศ. ${moment(obj.date.end).add(543, 'Y').year()}`
        break;
      case 'quarter':
        title +=  ` ในไตรมาสที่ ${moment(obj.date.start).quarter()} ปี พ.ศ. ${moment(obj.date.start).add(543, 'Y').year()}`
        break;
      case 'between_quarter':
        title +=  ` ในไตรมาสที่ ${moment(obj.date.start).quarter()} ปี พ.ศ. ${moment(obj.date.start).add(543, 'Y').year()} ถึงไตรมาสที่ ${moment(obj.date.end).quarter()} ปี พ.ศ. ${moment(obj.date.end).add(543, 'Y').year()}`
        break;
    }
    newChart.title.text = title
    let data = obj.qrydata
    let speed = []
    for(let data_qry = 0; data_qry < data.length; data_qry++){
      speed.push((data[data_qry].download_speed ? data[data_qry].download_speed : '-') + '/' + (data[data_qry].upload_speed ? data[data_qry].upload_speed : '-') + ' Mbps')
    }
    let dis_speed = speed.filter((val,index) => speed.indexOf(val) == index)
    newChart.xAxis.categories = dis_speed
    console.log(dis_speed)
    let provider_arr =[]
    let drilldown_list = []
    for(let pr = 0; pr < providers.length; pr++){
      provider_arr[pr] = []
      for(let r = 0; r < dis_speed.length; r++){
        let provider_id  = obj.forminfo.compare_type == 'group' ? JSON.parse(providers[pr].group_company_list) : [providers[pr].id]
        let rowdata = data.filter(item => provider_id.includes(item.provider_id) && dis_speed[r].includes((item.download_speed ? item.download_speed : '-') + '/' + (item.upload_speed ? item.upload_speed : '-') + ' Mbps'))
        let count = 0
        let drilldown = {
          name: dis_speed[r] + '_' + providers[pr].brand_name,
          id: dis_speed[r] + '_' + providers[pr].brand_name,
          data: []
        }
        for(let row = 0; row < rowdata.length; row++){
          count++
          drilldown.data.push({ name: rowdata[row].promotion_code, y: rowdata[row].promotion_price, labels: rowdata[row].promotion_name_th})
        }
        if(count){
          provider_arr[pr].push({
            name: dis_speed[r],
            y: parseInt(formatNumber(count)),
            drilldown: drilldown.id
          })
          drilldown.data.length > 20 ? drilldown.dataLabels = {enabled: true, rotation: 90, y: 0, align: 'left'} :  null
          drilldown_list.push(drilldown)
        } else {
          provider_arr[pr].push(null)
        }
      }
    }
    for(let p = 0; p < providers.length; p++){
      let provider_name = obj.forminfo.compare_type == 'group' ? providers[p].group_name_th : providers[p].brand_name
      let provider_color = obj.forminfo.compare_type == 'group' ? providers[p].group_color_code : providers[p].provider_color
       newChart.series.push({
        name: provider_name,
        data: provider_arr[p],
        color: provider_color
      })
    }
    let count = 0
    for(let item of provider_arr){
      count += item.length
    }
    let fontsize = 9 - Math.round(count/100)+'px'
    newChart.plotOptions.column.dataLabels.rotation = count > 60 ? 270 : 0
    newChart.plotOptions.column.dataLabels.align = count > 60 ? 'left' : 'center'
    newChart.drilldown = {
      drillUpButton: {
        position: {
          align: 'left',
          y: -20
        }
      },
      activeDataLabelStyle: {
        textDecoration: 'none',
        // fontWeight: 'thin',
        fontSize: fontsize
      }
    }
    newChart.xAxis.labels.style.fontSize = fontsize
    newChart.xAxis.labels.padding = 0
    newChart.xAxis.labels.autoRotation = [-80]
    newChart.drilldown.series = drilldown_list
    newChart.chart.events = {
      drilldown: function(e) {
          this.yAxis[0].setTitle({ text: 'ค่าบริการ (บาท/เดือน)' });
          // this.xAxis[0].setCategories( e.seriesOptions.data.map(data => data[0]))
      },
      drillup: function(e) {
          this.yAxis[0].setTitle({ text: 'จำนวนรายการส่งเสริมการขาย (รายการ)' });
          // this.xAxis[0].setCategories(dis_speed)
      }
  }
  newChart.tooltip = {
    formatter: function() {
      if(this.point.drilldown == undefined) {
        return '<b>' + this.series.name + '</b><br><b>' + this.point.labels+': ' + this.point.y + ' บาท'+'</b>';
      } else {
        return '<b>' + this.series.name + '</b><br><b>' + this.point.name+': ' + this.point.y + ' รายการ'+'</b>';
      }
     }
  },
  newChart.plotOptions.series = {
      cursor: 'pointer',
      events: {
          click: function (event) {
            // console.log(event.point.drilldown)
            // console.log(event.point)
            // console.log(this.chart.series)
          }
      }
    }
  // newChart.xAxis.categories = dis_speed
    state.charts.push(newChart)
  }
};
function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
export const Report_SI = {
  namespaced: true,
  state,
  actions,
  mutations
};
